import { Check, Phone, MessageSquare, Wifi, Tag } from "lucide-react";
import { OFFERS, SITE } from "@/config/siteConfig";
import { waLink, trackEvent } from "@/lib/whatsapp";
import { Reveal } from "@/components/Reveal";

export const Offers = () => (
  <section id="offres" className="bg-white py-24 md:py-32" data-testid="offers-section">
    <div className="mx-auto max-w-7xl px-4 md:px-8">
      <Reveal className="mb-14 max-w-2xl">
        <p className="mb-3 font-display text-xs font-bold uppercase tracking-[0.3em] text-gray-400">01 — Nos offres</p>
        <h2 className="font-display text-3xl font-extrabold tracking-tight text-black sm:text-4xl lg:text-5xl">
          Des forfaits pensés pour votre quotidien
        </h2>
        <p className="mt-4 text-base text-gray-600 md:text-lg">
          Comparez nos forfaits mobiles, choisissez celui qui vous convient, puis écrivez-nous. Un conseiller s'occupe du reste.
        </p>
      </Reveal>

      <div className="grid gap-6 md:grid-cols-3 md:gap-8">
        {OFFERS.map((offer, i) => (
          <Reveal key={offer.id} delay={i * 0.12}>
            <article
              className={`relative flex h-full flex-col rounded-3xl border bg-white p-7 shadow-sm transition-transform duration-300 hover:-translate-y-1.5 ${
                offer.featured ? "border-jeem-yellow ring-4 ring-jeem-yellow/30" : "border-gray-200"
              }`}
              data-testid={`offer-card-${offer.id}`}
            >
              {offer.featured && (
                <span className="absolute -top-3.5 left-7 rounded-full bg-jeem-yellow px-4 py-1 text-xs font-bold uppercase tracking-wider text-black">
                  Le plus populaire
                </span>
              )}
              <h3 className="font-display text-lg font-bold text-black">{offer.name}</h3>
              <p className="mt-5 font-display text-5xl font-extrabold tracking-tight text-black">{offer.data}</p>
              <p className="mt-1 text-sm text-gray-500">de données mobiles</p>

              <div className="mt-5 space-y-2 border-t border-gray-100 pt-5 text-sm text-gray-700">
                <p className="flex items-center gap-2.5"><Phone className="h-4 w-4 text-gray-400" /> {offer.calls}</p>
                <p className="flex items-center gap-2.5"><MessageSquare className="h-4 w-4 text-gray-400" /> {offer.texts}</p>
                <p className="flex items-center gap-2.5"><Wifi className="h-4 w-4 text-gray-400" /> Réseau fiable et rapide</p>
              </div>

              <ul className="mt-5 space-y-2.5">
                {offer.perks.map((perk) => (
                  <li key={perk} className="flex items-start gap-2.5 text-sm font-medium text-gray-800">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-jeem-yellow/25">
                      <Check className="h-3 w-3 text-black" strokeWidth={3} />
                    </span>
                    {perk}
                  </li>
                ))}
              </ul>

              <div className="mt-auto pt-7">
                <a
                  href={waLink(offer.priceMessage)}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => trackEvent("clic_prix_whatsapp", { offre: offer.id })}
                  data-testid={`offer-price-link-${offer.id}`}
                  className="mb-5 flex items-center gap-2.5 rounded-2xl bg-jeem-yellow/20 px-4 py-3.5 transition-colors duration-300 hover:bg-jeem-yellow/50"
                >
                  <Tag className="h-4 w-4 shrink-0 text-black" />
                  <span className="text-sm font-bold leading-snug text-black underline decoration-jeem-yellow decoration-2 underline-offset-2">{SITE.priceNote}</span>
                </a>
                <a
                  href={waLink(offer.whatsappMessage)}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => trackEvent("clic_offre", { offre: offer.id })}
                  data-testid={`offer-interested-btn-${offer.id}`}
                  className={`flex h-13 min-h-[52px] items-center justify-center rounded-full text-base font-bold transition-colors duration-300 ${
                    offer.featured
                      ? "bg-black text-white hover:bg-gray-800"
                      : "bg-gray-100 text-black hover:bg-jeem-yellow"
                  }`}
                >
                  Je suis intéressé
                </a>
              </div>
            </article>
          </Reveal>
        ))}
      </div>

      <p className="mt-8 text-xs text-gray-400" data-testid="offers-demo-notice">
        * Données et avantages présentés à titre d'exemple — contenu de démonstration en attendant les offres officielles. Prix sur demande via WhatsApp.
      </p>
    </div>
  </section>
);
